// src/MetalProvider.tsx
import { I18nContext } from "@brexhq/metal-theming-shared";
import { useContext } from "react";
import { jsx } from "react/jsx-runtime";
var MetalProvider = ({
  locale = "en-US",
  children
}) => {
  const [languageCode, countryCode] = locale.split("-");
  return /* @__PURE__ */ jsx(I18nContext.Provider, {
    value: { locale, languageCode, countryCode },
    children
  });
};
var useLocale = () => useContext(I18nContext);
export {
  MetalProvider,
  useLocale
};
